import { UploadedReceipt, BookingImportJob } from '../../../types';

import { apiRequest } from './client';
import { CreateReceiptRequest, ProposeChangeRequest } from './types';

// Create an uploaded receipt
export const createUploadedReceipt = async (
  data: CreateReceiptRequest,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: '/uploaded-receipts',
    method: 'POST',
    token,
    body: data,
  });
};

// Get uploaded receipts by IDs
export const getUploadedReceipts = async (
  ids: string[],
  token: string
): Promise<UploadedReceipt[]> => {
  const idsParam = ids.join(',');
  return apiRequest<UploadedReceipt[]>({
    endpoint: `/uploaded-receipts?ids=${encodeURIComponent(idsParam)}`,
    method: 'GET',
    token,
  });
};

// Get a single uploaded receipt by ID
export const getUploadedReceiptById = async (
  receiptId: string,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: `/uploaded-receipts/${receiptId}`,
    method: 'GET',
    token,
  });
};

// Propose changes to a receipt's booking data
export const proposeReceiptChange = async (
  receiptId: string,
  request: ProposeChangeRequest,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: `/uploaded-receipts/${receiptId}/propose-change`,
    method: 'POST',
    token,
    body: request,
  });
};

// Reject a receipt
export const rejectReceipt = async (
  receiptId: string,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: `/uploaded-receipts/${receiptId}/reject`,
    method: 'POST',
    token,
  });
};

// Import a receipt (returns async BookingImportJob)
export const importReceipt = async (
  receiptId: string,
  token: string
): Promise<BookingImportJob> => {
  return apiRequest<BookingImportJob>({
    endpoint: `/booking-import-jobs/from-receipt/${receiptId}`,
    method: 'POST',
    token,
  });
};

// Retry text extraction for a failed receipt
export const retryReceiptExtraction = async (
  receiptId: string,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: `/uploaded-receipts/${receiptId}/retry-extraction`,
    method: 'POST',
    token,
  });
};

// Delete an uploaded receipt
export const deleteUploadedReceipt = async (
  receiptId: string,
  token: string
): Promise<void> => {
  return apiRequest<void>({
    endpoint: `/uploaded-receipts/${receiptId}`,
    method: 'DELETE',
    token,
  });
};
